global.host = {
    uri: "https://app.digitalisierungs-cockpit.de/",
    api: "?type=3000"
};

global.etrackerCode = '0M9AHV';

if((location.href.indexOf('localhost') !== -1)) {
    global.host.uri = "http://digicockpit.rkw.local/";
    global.etrackerCode = ''
}

if((location.href.indexOf('rkw.local') !== -1)) {
    global.host.uri = "http://digicockpit.rkw.local/";
    global.etrackerCode = ''
}

if((location.href.indexOf('rkw.codes') !== -1)) {
    global.host.uri = "http://digicockpit.rkw.codes/";
    global.etrackerCode = '';
}


export default {
    state: {
        runtime: {
            activeItems: {
                model: null,
                mechanism: null,
                task: null,
                instance: null
            },
            allItems: {
                instances: [],
                tasks: [],
                related: {

                }
            },
            content: {
                flip: false,
                zoom: false
            },
            bookmarks: {
                open: false,
                entries: []
            },
            contact: null,
            tutorial: true,
            openNavigation: null
        },
        settings: {
            "class": "c-tile-nav__tile",
            "subclass": "c-tile-nav__tile-sub",
            "sub2class": "c-tile-nav__tile-sub2",
            "pageUrl": host.uri,
            colors: {
                "--color-1": "#B89762",
                "--color-2": "#5E5664",
                "--color-3": "#7E7F59",
                "--color-4": "#306A7E"
            }
        },
        data: null
    },
    mutations: {
        setActiveItems: function(state, item) {
            state.runtime.activeItems[item['type']] = item['uid']
        },
        unsetActiveItems: function (state) {
            state.runtime.activeItems['model'] = null
            state.runtime.activeItems['mechanism'] = null
            state.runtime.activeItems['task'] = null
            state.runtime.activeItems['instance'] = null
        },
        setActiveInstance: function (state, instanceID) {
            let instanceObj = (!instanceID) ? null : state.data.instances[instanceID],
                taskObj = (!instanceID) ? null : state.data['tasks'][instanceObj.parent],
                mechanismObj = (!instanceID) ? null : state.data['mechanisms'][taskObj.parent],
                modelObj = (!instanceID) ? null : state.data['models']['uid' + mechanismObj.parent]

            state.runtime.activeItems['model'] = (!instanceID) ? null : modelObj.id
            state.runtime.activeItems['mechanism'] = (!instanceID) ? null : mechanismObj.id
            state.runtime.activeItems['task'] = (!instanceID) ? null : taskObj.id
            state.runtime.activeItems['instance'] = (!instanceID) ? null : instanceID
        },
        unsetActiveInstance: function (state) {
            state.runtime.activeItems['mechanism'] = null
            state.runtime.activeItems['task'] = null
            state.runtime.activeItems['instance'] = null
        },
        extendRelatedInstances: function (state, params) {
            if(!state.runtime.allItems.related.hasOwnProperty(params['modelId'])) {
                state.runtime.allItems.related[params['modelId']] = []
            }
            Array.prototype.push.apply(state.runtime.allItems.related[params['modelId']], params['instances'])
        },
        extendInstances: function (state, instances) {
            Array.prototype.push.apply(state.runtime.allItems.instances, instances)
        },
        extendTasks: function (state, tasks) {
            Array.prototype.push.apply(state.runtime.allItems.tasks, tasks)
        },
        toggleContentFlip: function (state) {
            state.runtime.content.flip = !state.runtime.content.flip
        },
        toggleContentZoom: function (state) {
            state.runtime.content.zoom = !state.runtime.content.zoom
        },
        toggleBookmarkModal: function (state) {
            state.runtime.bookmarks.open = !state.runtime.bookmarks.open
        },
        closeBookmarkModal: function (state) {
            state.runtime.bookmarks.open = false
        },
        updateBookmarks: function (state, entries) {
            state.runtime.bookmarks.entries = JSON.parse(entries)
        },
        addBookmark: function (state, uid) {
            state.runtime.bookmarks.entries.push(parseInt(uid))
        },
        removeBookmark: function (state, uid) {
            uid = parseInt(uid)
            state.runtime.bookmarks.entries = state.runtime.bookmarks.entries.filter(bookmark => parseInt(bookmark) !== uid)
        },
        toggleTutorial: function (state) {
            state.runtime.tutorial = !state.runtime.tutorial
        },
        updateNavigationState: function (state) {
            if(state.runtime.activeItems.model !== null) {
                let pos = state.data.models['uid' + state.runtime.activeItems.model].position
                state.runtime.openNavigation = (pos.indexOf('left') !== -1) ? 'left' : 'right'
            } else {
                state.runtime.openNavigation = null
            }
        }
    },
    getters: {
        getBookmarkByUid: (state) => (id) => {
            return state.runtime.bookmarks.entries.find(bookmark => bookmark === id)
        }
    }
}


// WEBPACK FOOTER //
// ./source/vuejs/storage.js